var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 188,
    viewBox: "0 0 184 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(-883 711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-volume-mute",
    "data-name": "Icon awesome-volume-mute",
    d: "M69.518,6.778,40.755,35.535h-33A7.757,7.757,0,0,0,0,43.294V89.849a7.759,7.759,0,0,0,7.759,7.759h33l28.764,28.757a7.764,7.764,0,0,0,13.245-5.486V12.265A7.764,7.764,0,0,0,69.518,6.778Zm79.728,59.794L164,51.816a5.218,5.218,0,0,0,0-7.378l-7.378-7.378a5.218,5.218,0,0,0-7.378,0L134.491,51.816,119.736,37.061a5.218,5.218,0,0,0-7.378,0l-7.378,7.378a5.218,5.218,0,0,0,0,7.378l14.755,14.755L104.984,81.324a5.218,5.218,0,0,0,0,7.378l7.378,7.378a5.218,5.218,0,0,0,7.378,0l14.752-14.752,14.755,14.755a5.218,5.218,0,0,0,7.378,0L164,88.7a5.218,5.218,0,0,0,0-7.378Z",
    transform: "translate(892 -683.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 184,
    height: 188,
    transform: "translate(883 -711)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/sound-off.d42c5cdb2940d65d982b98278173ef44.svg";
export { ForwardRef as ReactComponent };